// External libraries
import React from 'react';
import { useStoreState } from '@/store';
import { DateOfBirth as DOB } from '@checkout/react-components';

// Internal modules
import { getContent } from '@/lib';
import { useMountLogging } from '@/lib/reactHooks';
import { cardSubFieldsContainerStyleOverrides } from '../styles';
import { blurHandler, changeHandler } from '../../../Form/handlers';
import { logBlurOrFocusEvent as focusHandler } from '../../../Form/utils';

const DateOfBirth = props => {
  useMountLogging('DateOfBirth');
  const dateOfBirth = useStoreState(({ form }) => form.dateOfBirth);
  const dateMeta = useStoreState(({ api }) => api.griffinMetadata.dateMeta);
  const isFormSubmitting = useStoreState(({ ui }) => ui.isFormSubmitting);

  return (
    <DOB
      blurHandler={blurHandler}
      changeHandler={changeHandler}
      containerStyleOverrides={cardSubFieldsContainerStyleOverrides}
      dateFormat={dateMeta.displayFormat}
      datePattern={dateMeta.datePattern}
      disabled={isFormSubmitting}
      focusHandler={focusHandler}
      id="dateOfBirth"
      label={getContent('fieldLabels.dob')}
      required={true}
      {...dateOfBirth}
    />
  );
};

export { DateOfBirth };
